import {documentType} from "../../actions/document/type";

const initialState = {
    pkCodes: null,
    uploadFileProgress: null,
    reload: false
};

const documentReducer = (state = initialState, action) => {
    switch (action.type) {
        case documentType.ON_CHANGE_UPLOAD_FILE_PROGRESS:
            return {
                ...state,
                uploadFileProgress: action.params
            }
        case documentType.ON_CHANGE_PK_CODE_ARRAY:
            return {
                ...state,
                pkCodes: action.params
            }
        case documentType.ON_CHANGE_RELOAD:
            return {
                ...state,
                reload: action.params
            }
        case documentType.POST_DOCUMENT_ATTACH_REQUEST:
            return {
                ...state,
                reload: action.data
            };
        case documentType.POST_DOCUMENT_ATTACH_SUCCESS:
            return {
                ...state,
                success: action.success
            };
        case documentType.POST_DOCUMENT_ATTACH_ERROR:
            return {
                ...state,
                error: action.error
            };
        default:
            return state;
    }
};

export default documentReducer;